import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";
export const getGraphEdges = (limit) => {
  try {
    const params = limit ? `?limit=${limit}` : "";
    return axios.get(BASE_URL + "graph/getConnectedNodeEdges" + params, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const getAllConnectedNodeEdgesTypes = () => {
  try {
    return axios.get(BASE_URL + "graph/getAllConnectedNodeEdgeTypes", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const getConnectedNodeByName = (nodeName, limit) => {
  try {
    let url = BASE_URL + "graph/getConnectedNodeByName?node_name=" + nodeName;
    if (limit) url += "&limit=" + limit;
    return axios.get(url, { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};
export const getConnectedNodeByType = (nodeType, limit) => {
  try {
    let url = BASE_URL + "graph/getConnectedNodeByType?node_type=" + nodeType;
    if (limit) url += "&limit=" + limit;
    return axios.get(url, { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};
export const getConnectedEdgeByType = (edgeType, limit) => {
  try {
    let url = BASE_URL + "graph/getConnectedEdgeByType?edge_type=" + edgeType;
    if (limit) url += "&limit=" + limit;
    return axios.get(url, { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};
export const getConnectedEdgeByName = (edgeName, limit) => {
  try {
    let url = BASE_URL + "graph/getConnectedEdgeByName?edge_name=" + edgeName;
    if (limit) url += "&limit=" + limit;
    return axios.get(url, { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};
export const createNode = (payload) => {
  try {
    return axios.post(BASE_URL + "graph/createNode", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const createEdge = (payload) => {
  try {
    return axios.post(BASE_URL + "graph/createEdge", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const deleteNode = (payload) => {
  try {
    return axios.delete(BASE_URL + "graph/deleteNode", {
      headers: authHeader(),
      data: payload,
    });
  } catch (e) {
    console.log(e);
  }
};
export const deleteEdge = (payload) => {
  try {
    return axios.delete(BASE_URL + "graph/deleteEdge", {
      headers: authHeader(),
      data: payload,
    });
  } catch (e) {
    console.log(e);
  }
};
export const updateNode = (payload) => {
  try {
    return axios.put(BASE_URL + "graph/updateNode", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const updateEdge = (payload) => {
  try {
    return axios.put(BASE_URL + "graph/updateEdge", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const getTeamGraphs = () => {
  try {
    return axios.get(BASE_URL + "graph/getTeamGraphs", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const getTeamMemberGraph = (userUuid, limit) => {
  try {
    let url = BASE_URL + "graph/getTeamMemberGraph?user_uuid=" + userUuid;
    if (limit) url += "&limit=" + limit;
    return axios.get(url, { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};
export const searchGraph = (query, limit, scope, userUuid, scopeValue) => {
  try {
    let url = BASE_URL + "graph/searchGraph?q=" + encodeURIComponent(query);
    if (limit) url += "&limit=" + limit;
    if (scope) url += "&scope=" + scope;
    if (userUuid) url += "&user_uuid=" + userUuid;
    if (scopeValue) url += "&scope_value=" + encodeURIComponent(scopeValue);
    return axios.get(url, { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};
export const getGlobalGraph = (limit) => {
  try {
    const params = limit ? `?limit=${limit}` : "";
    return axios.get(BASE_URL + "graph/getGlobalGraph" + params, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getGraphCounts = (scope, userUuid, scopeValue, filters) => {
  try {
    if (scope === "custom_view" && filters) {
      return axios.post(BASE_URL + "graph/getGraphCounts", {
        scope,
        user_uuid: userUuid || "",
        filters,
      }, { headers: authHeader() });
    }
    let url = BASE_URL + "graph/getGraphCounts";
    const params = [];
    if (scope) params.push("scope=" + encodeURIComponent(scope));
    if (userUuid) params.push("user_uuid=" + encodeURIComponent(userUuid));
    if (scopeValue) params.push("scope_value=" + encodeURIComponent(scopeValue));
    if (params.length) url += "?" + params.join("&");
    return axios.get(url, { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};

// ── Graph Views & Favorites ──────────────────────────────────────────────
export const getGraphViews = () => {
  try {
    return axios.get(BASE_URL + "graph/getGraphViews", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const getGraphSources = () => {
  try {
    return axios.get(BASE_URL + "graph/getGraphSources", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const getFilteredGraphView = (payload) => {
  try {
    return axios.post(BASE_URL + "graph/getFilteredGraphView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const getFilteredGraphViewStats = (payload) => {
  try {
    return axios.post(BASE_URL + "graph/getFilteredGraphViewStats", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const createGraphView = (payload) => {
  try {
    return axios.post(BASE_URL + "graph/createGraphView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const updateGraphView = (payload) => {
  try {
    return axios.put(BASE_URL + "graph/updateGraphView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const deleteGraphView = (payload) => {
  try {
    return axios.delete(BASE_URL + "graph/deleteGraphView", {
      headers: authHeader(),
      data: payload,
    });
  } catch (e) {
    console.log(e);
  }
};
export const favoriteGraphView = (payload) => {
  try {
    return axios.post(BASE_URL + "graph/favoriteGraphView", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
export const unfavoriteGraphView = (payload) => {
  try {
    return axios.delete(BASE_URL + "graph/unfavoriteGraphView", {
      headers: authHeader(),
      data: payload,
    });
  } catch (e) {
    console.log(e);
  }
};

export const saveGraphViewOrder = (payload) => {
  try {
    return axios.post(BASE_URL + "graph/saveGraphViewOrder", payload, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
